import React, { Component } from 'react';
import ReactLoading from 'react-loading';

import withStyles from '@mui/styles/withStyles';

import kSpinnerStyle from '../assets/jss/crm/components/kSpinnerStyle.jsx';

/*
  Call this most simply with
    <KSpinner />
  If you want a slightly fancier graphic, you can use
    <KSpinner type="spinningBubbles" />
  or
    <KSpinner type="spokes" />
  You can also affect the size with, for example,
    <KSpinner size={100} />
*/

class KSpinner extends Component {
  render() {
    const { classes, type, size } = this.props;
    return (
      <ReactLoading
        className={classes.loadingSpinner}
        type={type ? type : 'spin'}
        color="#999"
        width={size ? size : 64}
        height={size ? size : 64}
      />
    );
  }
}

export default withStyles(kSpinnerStyle)(KSpinner);
